import styled from 'styled-components'
import { whenSidebarFits } from '../../theme'

export const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  width: 100vw;
  min-height: 100%;
  margin: 0 auto;

  &::after {
    content: '';
  }

  @media (${whenSidebarFits}) {
    align-items: start;
    flex-flow: row nowrap;
  }
`
